import React from 'react';
import LiveMaterialTable from 'common/components/LiveMaterialTable';
import AddIcon from '@material-ui/icons/LibraryAdd';
import SettingsIcon from '@material-ui/icons/Settings';
import { calculateHeight } from '../../common/services/util';
import TableTitle from 'common/components/TableTitle';

const TableClients = ({
        columns,
        loading,
        data,
        onClientAdd,
        onClientUpdate,
        onClientDelete,
        handleOpenSettings,
        tableRefProp,
        getRowStyle,
        extraActions = []
    }) => {
    return (
        <div className="zebra-table">
            <LiveMaterialTable
                title={<TableTitle>Clientes</TableTitle>}
                tableRef={tableRefProp}
                icons={{
                    'Add': () => <AddIcon fontSize='large' color='primary'></AddIcon>
                }}
                actions={[
                    {
                        icon: () => <SettingsIcon />,
                        onClick: () => handleOpenSettings(true),
                        isFreeAction: true
                    },
                    ...extraActions
                ]}
                columns={columns}
                isLoading={loading}
                data={data}
                options={{
                    search: false,
                    sorting: true,
                    actionsColumnIndex: 1,
                    filtering: true,
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    rowStyle: (rowData, index) => (getRowStyle ? getRowStyle(rowData, index) : {})
                }}
                editable={{
                    onRowAdd: onClientAdd,
                    onRowUpdate: onClientUpdate,
                    onRowDelete: onClientDelete
                }}
            />
        </div>
    )
}

export default TableClients
